
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip6)"}},[_c('path',{attrs:{"d":"M18.682 22.916c-.634.369-1.2.685-1.752 1.022-.208.126-.359.037-.525-.058l-7.212-4.151a1.154 1.154 0 01-.471-.46 1.178 1.178 0 01-.146-.647c.011-1.285-.014-2.57 0-3.856.01-.566-.147-.623-.608-.351-1.677.99-3.365 1.96-5.054 2.933-1.337.776-2.42.153-2.42-1.405C.498 11.204.5 6.473.5 1.745.5.173 1.575-.444 2.926.339 5.18 1.644 7.424 2.97 9.687 4.265c.604.342.885.776.864 1.485-.04 1.414 0 2.83-.018 4.242 0 .5.1.607.558.336 1.72-1.014 3.45-1.987 5.157-3.007a.79.79 0 01.973.011c.437.295.905.541 1.365.81-.076.297-.336.336-.521.445-2.325 1.357-4.65 2.714-6.985 4.036a.93.93 0 00-.428.384.95.95 0 00-.124.564 86.75 86.75 0 010 3.984.946.946 0 00.121.57c.1.172.25.308.43.386 2.321 1.317 4.627 2.658 6.938 3.992.197.113.388.239.665.413zM2.482 8.85v5.783c0 .457.06.65.553.357a295.445 295.445 0 015.157-2.992.712.712 0 00.397-.713 213.38 213.38 0 010-4.82.81.81 0 00-.108-.478.793.793 0 00-.362-.325 364.819 364.819 0 01-5.046-2.937c-.46-.275-.604-.225-.598.341.019 1.927.008 3.856.008 5.784z","fill":"#748190"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip6"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.501)","d":"M0 0h18.182v24H0z"}})])])])
          )
        }
      }
    